import React, { useEffect } from 'react'
import { Select } from '@st-operations/uikit/src/v2'

export const TIME_INTERVAL_VALUES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
}

const IntervalSelect = ({
  label = 'Time Interval',
  interval,
  intervalOptions = [
    { label: 'Daily', value: TIME_INTERVAL_VALUES.DAILY },
    { label: 'Weekly', value: TIME_INTERVAL_VALUES.WEEKLY },
    { label: 'Monthly', value: TIME_INTERVAL_VALUES.MONTHLY },
  ],
  onIntervalChange = () => null,
}) => {
  useEffect(() => {
    if (intervalOptions.findIndex((opt) => opt.value === interval) === -1) {
      onIntervalChange(intervalOptions[0].value)
    }
  }, [intervalOptions])

  return (
    <Select
      label={label}
      options={intervalOptions}
      value={interval}
      onChange={({ value }) => onIntervalChange(value)}
      useReactSelect
    />
  )
}

export default IntervalSelect
